import type React from "react";
import { Button } from "@planta-v2/pds-ui/button";
import { i18n } from "@frontend/i18n";
import { SsoSource } from "@shared/schemas/sso-source.schemas";

export interface GoogleSsoButtonProps {
  readonly returnUrl: string;
}

function getApiBaseUrl(): string {
  // eslint-disable-next-line planta-v2/unknown-only-at-boundaries -- Environment variables are external runtime input
  const envUrl: unknown = import.meta.env["VITE_API_BASE_URL"];
  return typeof envUrl === "string" && envUrl.length > 0 ? envUrl : "";
}

const GoogleGlyph = (): React.JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    className="h-4 w-4"
  >
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.62z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"
    />
  </svg>
);

export function GoogleSsoButton({
  returnUrl,
}: GoogleSsoButtonProps): React.JSX.Element {
  const handleClick = (): void => {
    const params = new URLSearchParams({
      source: SsoSource.GOOGLE,
      redirect: returnUrl,
    });
    window.location.href = `${getApiBaseUrl()}/api/v1/auth/sessions/oauth?${params.toString()}`;
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      data-testid="login-google-sso-button"
      variant="outline"
      size="lg"
      className="w-full border-border text-foreground"
    >
      <GoogleGlyph />
      {i18n.t("login.signInWithGoogle")}
    </Button>
  );
}
